import useAppStore from "@/context/store";
import setCloseAds from "@/utils/closeAds";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import classNames from "classnames";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { When } from "react-if";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

export default function GloablBanner({ onClose, visible, record }) {
  const adRef = useRef();
  const link = useMemo(() => {
    const link = record?.material.link || "";
    const href = link.split("?")[0] || "";
    const search = link.split("?")[1] || "";
    const params =
      search
        ?.split("&")
        ?.filter((item) => !item.startsWith("color="))
        ?.join("&") || "";

    return `${href}${params ? `?${params}` : ""}`;
  }, [record]);

  const color = useMemo(() => {
    const link = record?.material.link || "";
    const search = link.split("?")[1] || "";
    const color =
      search
        ?.split("&")
        ?.find((item) => item.startsWith("color="))
        ?.replace("color=", "") || "transparent";
    return color;
  }, [record]);

  const onCloseBanner = useCallback(
    (evt) => {
      evt.preventDefault();
      setCloseAds(record.material);
      onClose && onClose();
    },
    [onClose, record]
  );

  // 解决adblock的广告屏蔽导致空白一行问题
  // 曾尝试样式添加important仍无法覆盖插件的样式
  useEffect(() => {
    if (adRef.current && visible) {
      if (adRef.current.offsetHeight === 0) {
        useAppStore.setState({
          headerHeight: 60,
        });
      }
    }
  }, [visible]);

  const imageSrc = useMemo(() => {
    const url = `//${record?.material.data.bucket_name}.huaban.com/${record?.material.data.bucket_key}`;
    // 展示合适的图片尺寸
    return gdImgSrcPolicy(url, {
      displayHeight: 60, // 显示宽度
      aspectRatio: 60 / 1920, // 高宽比
      width: record?.material?.width, // 图片原始宽度
      height: record?.material?.height, // 图片原始高度
      type: null, // 图片类型, 这里避免转换成webp，导致图片清晰度下降
    });
  }, [record]);

  if (!visible) {
    return null;
  }

  return (
    <a
      ref={adRef}
      className={classNames(styles.banner, ["modalOpenWidth"])}
      style={{ backgroundColor: color }}
      target="_blank"
      href={link}
      data-gd-click="resource_loc_click"
      data-gd-expose="resource_loc_expose"
      data-resource-type="图片"
      data-resource-id={record?.material.id}
      data-resource-title={record?.promotion.name}
      data-content-source={record?.position.alias}
      rel="noreferrer nofollow"
    >
      <When condition={record}>
        <img {...imageSrc} alt={record?.material.tag} />
      </When>
      <div
        className={styles.close}
        onClick={onCloseBanner}
        data-gd-click="button_click"
        data-button-name="关闭广告"
      >
        <HBIcon type="ic_clear2" />
      </div>
      <When condition={record?.material.tag}>
        <div className={styles.label}>{record?.material.tag}</div>
      </When>
      <When condition={record?.material.tracker}>
        <img
          src={record?.material.tracker}
          alt="埋点"
          style={{ display: "none" }}
        />
      </When>
    </a>
  );
}
